import { useState, useEffect } from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { costoService } from '@/services/costoService';

export interface NombreSugeridoOption {
  id: string;
  nombre: string;
}

export const useNombresSugeridos = (search: string) => {
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useEffect(() => {
    const normalizado = search.trim().toLowerCase();
    const timer = setTimeout(() => setDebouncedSearch(normalizado), 300);
    return () => clearTimeout(timer);
  }, [search]);

  const { data, isFetching } = useQuery({
    queryKey: ['presupuesto-items', 'nombres', debouncedSearch],
    queryFn: () => costoService.getNombresSugeridos(debouncedSearch),
    enabled: debouncedSearch.length >= 2,
    staleTime: 1000 * 60,
    placeholderData: keepPreviousData,
  });

  const opciones: NombreSugeridoOption[] = (data || []).map((nombre) => ({
    id: nombre,
    nombre,
  }));

  const isPending = debouncedSearch !== search.trim().toLowerCase();

  return { opciones, isLoading: isFetching || isPending };
};
